import { render } from "./Games.vue?vue&type=template&id=bc76a024&scoped=true"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"

import "./Games.vue?vue&type=style&index=0&id=bc76a024&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc76a024"]])

export default __exports__